import { styled, Box } from '@mui/material';

export const DashboardVariantV1Container = styled(Box)(({ theme }) => ({
  display: 'grid',
  gap: theme.spacing(3),
  gridTemplateColumns: '1fr max-content',
}));

export const DashboardVariantV1GridStack = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'direction' && prop !== 'spacing',
})<{ direction?: 'row' | 'column'; spacing?: number }>(
  ({ theme, direction = 'row', spacing = 0 }) => ({
    display: 'grid',
    gap: theme.spacing(spacing),
    gridAutoFlow: direction,
  }),
);
